module.exports = __webpack_public_path__ + "img/jinxiaocun1.450e438c.png";